import React from "react";
import CardComponent from "./CardComponent";

const headerBarStyle = {
  textAlign: "left",
  padding: "18px 20px",
};

/** Top padding includes overlap offset so content stays aligned after body margin-top (see .mfl-card--dashboard-panel) */
const DASH_PANEL_BODY_SEAM = 16;
const bodyPaddingStyle = {
  padding: `${20 + DASH_PANEL_BODY_SEAM}px 24px 20px 24px`,
};

/**
 * Blue header (#335CAD) + light blue bordered body — shared shell for upcoming appointments,
 * bloodwork, documents, and similar dashboard blocks. Use framed={false} for chromeless wrapper only.
 */
export default function DashboardPanelCard({
  title,
  header,
  children,
  framed = true,
  className = "",
  style,
  bodyStyle,
  headerStyle,
}) {
  if (!framed) {
    return (
      <div className={className} style={{ width: "100%", ...style }}>
        {children}
      </div>
    );
  }

  const resolvedHeader =
    header ??
    (title != null && title !== "" ? (
      <span
        style={{
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          lineHeight: 1.2,
          fontFamily: "Montserrat, sans-serif",
        }}
      >
        {title}
      </span>
    ) : null);

  return (
    <CardComponent
      className={`mfl-card--dashboard-panel ${className}`.trim()}
      style={{ width: "100%", boxSizing: "border-box", ...style }}
      header={resolvedHeader}
      headerColor="#335CAD"
      borderColor="#C2E6F8"
      borderWidth={1}
      headerStyle={{ ...headerBarStyle, ...headerStyle }}
      bodyStyle={{ ...bodyPaddingStyle, ...bodyStyle }}
    >
      {children}
    </CardComponent>
  );
}
